var _excluded = ["label", "floatingLabel", "condensed", "error", "className", "value", "describedBy"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import { InputPhoneInt } from '@cb/apricot-react';
var InternationalPhoneControl = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _validate;
  var label = _ref.label,
    _ref$floatingLabel = _ref.floatingLabel,
    floatingLabel = _ref$floatingLabel === void 0 ? false : _ref$floatingLabel,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    error = _ref.error,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    value = _ref.value,
    describedBy = _ref.describedBy,
    input = _objectWithoutProperties(_ref, _excluded);
  var validation = ((_validate = validate) !== null && _validate !== void 0 ? _validate : error) ? 'error' : undefined;
  return /*#__PURE__*/React.createElement(InputPhoneInt, _extends({
    inputId: input.id,
    className: className,
    disabled: input.disabled,
    condensed: condensed,
    defaultValue: value,
    required: input.required,
    label: label,
    ref: ref,
    floating: floatingLabel,
    validation: validation,
    validationMsg: error,
    "aria-describedby": describedBy
  }, input));
});
InternationalPhoneControl.displayName = 'InternationalPhone';
export default InternationalPhoneControl;